import { z } from "zod";

import { LocalDateSchema } from "./daily-entry";

export const CIRCLE_COMMENT_MAX_LENGTH = 500;

export const CreateCircleCommentSchema = z.object({
  message: z.string().trim().min(1).max(CIRCLE_COMMENT_MAX_LENGTH),
  targetUserId: z.string().nullish(),
  localDate: LocalDateSchema.nullish(),
});

export const CircleCommentResponseSchema = z.object({
  id: z.string(),
  circleId: z.string(),
  authorUserId: z.string(),
  authorDisplayName: z.string(),
  targetUserId: z.string().nullable(),
  targetDisplayName: z.string().nullable(),
  localDate: LocalDateSchema.nullable(),
  message: z.string(),
  createdAt: z.string().datetime(),
});

export const CircleCommentsListResponseSchema = z.object({
  comments: z.array(CircleCommentResponseSchema),
});

export const CreateCircleCommentResponseSchema = z.object({
  comment: CircleCommentResponseSchema,
});

export type CreateCircleCommentInput = z.infer<typeof CreateCircleCommentSchema>;
export type CircleCommentResponse = z.infer<typeof CircleCommentResponseSchema>;
export type CircleCommentsListResponse = z.infer<typeof CircleCommentsListResponseSchema>;
export type CreateCircleCommentResponse = z.infer<typeof CreateCircleCommentResponseSchema>;
